import { Map as ImmutableMap } from 'immutable';
import { isConfigKeyGenericChannelId } from '../../public/operators';
export const buildChannelConfigurationMap = data => {
  return Object.entries(data).reduce((configMap, [editorKey, channelConfiguration]) => {
    const formattedKey = isConfigKeyGenericChannelId(editorKey) ? parseInt(editorKey, 10) : editorKey;
    return channelConfiguration ? configMap.set(formattedKey, channelConfiguration) : configMap;
  }, ImmutableMap());
};